import quickBooksReducer from '@sophocles/features/quickbooks/slice';

export default quickBooksReducer;
